<script>
  import Grid from "../atoms/Grid.svelte";
  import GridContainer from "../atoms/GridContainer.svelte";
  import Image from "../atoms/Image.svelte";
  import { getTheme } from "../utilities/themes";
  // eslint-disable-next-line no-unused-vars
  import * as Types from "../types/shared";
  import Rule from "../atoms/Rule.svelte";
  import Tags from "../atoms/Tags.svelte";
  import DynamicHeading from "../atoms/DynamicHeading.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * Additional classes which apply to the container
   * @type { string }
   * */
  let className = "";
  export { className as class };

  /**
   * The title of the hero section
   * @type {string}
   */
  export let title;
  /**
   * The subtitle of the hero section
   * @type {string}
   */
  export let subtitle = null;
  /**
   * The eyebrow in the hero section.
   * @type {import("../atoms/Tags.svelte").Tag[]}
   */
  export let tags = null;
  /**
   * The featured image in the hero section
   * @type {Types.Image}
   */
  export let featuredImage = null;
  /**
   * The theme of the hero section
   * @type {import($lib/utilities/theme.js').ThemeName} ThemeName
   */
  export let theme = "white";
  $: currentTheme = getTheme(theme) || {};

  /**
   * The image variant of the hero section
   * @type {keyof typeof imageAspectRatios}
   */
  export let imageVariant = null;

  let hasHalfWidthImage = featuredImage && imageVariant !== "landscape";

  const contentClass = hasHalfWidthImage
    ? "md:col-span-6 md:flex md:flex-col md:h-full md:min-h-[450px]"
    : "";
  const imageClass = hasHalfWidthImage ? "md:col-span-6" : "md:mt-7 lg:mt-10";
  const imageAspectRatios = {
    square: "aspect-1/1",
    portrait: "aspect-3/4",
    landscape: "aspect-3/2"
  };
</script>

<GridContainer
  {id}
  containerElement="section"
  containerClass="{currentTheme.backgroundColor} {currentTheme.textColor} pt-15 pb-7.5 md:pt-20 lg:pb-15 xl:pt-25"
>
  <Grid gridClass={className}>
    <div class="col-full-width {contentClass}">
      <div class="md:grow">
        <Rule type="thick" {theme} />
        <div class="md:max-w-[600px] lg:max-w-[1000px] xl:max-w-[1400px]">
          <!-- Since Heroes are generally H1, we don't wrap with DynamicHeadingContext 
          to bump the heading level -->
          <DynamicHeading class="heading-lg mt-4 lg:mt-6">{title}</DynamicHeading>
          {#if subtitle}
            <p class="body-md mt-4 md:mt-7.5 md:max-w-[530px] lg:max-w-[700px] xl:max-w-[940px]">
              {subtitle}
            </p>
          {/if}
        </div>
      </div>
      {#if tags}
        <Tags
          {theme}
          {tags}
          class="heading-xs mt-25 gap-x-5 gap-y-2 md:mt-36 "
          bulletClass="after:{currentTheme.ruleColor}"
        />
      {/if}
    </div>
    {#if featuredImage}
      <div class="col-full-width max-md:mt-7 {imageClass}">
        <Image {...featuredImage} aspectRatioClasses={imageAspectRatios[imageVariant]} />
      </div>
    {/if}
  </Grid>
</GridContainer>
